module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_5.f8e6719b.png";